

import React, { useState, useEffect } from 'react';

const SITE_KEY = '6LfRD8srAAAAAP3dpjpU3KGOzrOJbfgAGTx-KHdG';



export default function RegistroNeuroterapeuta({ tenant_id, onSuccess }) {
  const [form, setForm] = useState({ nombre: '', email: '', telefono: '', password: '', especialidad: '', avatar: null });
  const [error, setError] = useState('');
  const [ok, setOk] = useState(false);
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(null);

  // Cargar el script de reCAPTCHA v3 solo una vez
  useEffect(() => {
    if (!window.grecaptcha) {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const handleChange = e => {
    const { name, value, files } = e.target;
    if (name === 'avatar') {
      setForm(f => ({ ...f, avatar: files[0] }));
      setPreview(files[0] ? URL.createObjectURL(files[0]) : null);
    } else {
      setForm(f => ({ ...f, [name]: value }));
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setOk(false);
    setLoading(true);
    try {
      // Ejecutar reCAPTCHA v3 antes de enviar el formulario
      if (!window.grecaptcha) throw new Error('No se pudo cargar reCAPTCHA');
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(SITE_KEY, { action: 'registro' }).then(async token => {
          // Ahora sí enviar el formulario
          const fd = new FormData();
          fd.append('nombre', form.nombre);
          fd.append('email', form.email);
          fd.append('telefono', form.telefono);
          fd.append('password', form.password);
          fd.append('especialidad', form.especialidad);
          if (form.avatar) fd.append('avatar', form.avatar);
          fd.append('recaptcha', token);
          if (tenant_id) fd.append('tenant_id', tenant_id);
          const res = await fetch('https://api.braineka.com/usuarios/registro', {
            method: 'POST',
            body: fd
          });
          if (!res.ok) {
            let msg = 'Error en el registro';
            try {
              const data = await res.json();
              msg = data.error || msg;
            } catch {}
            throw new Error(msg);
          }
          setOk(true);
          setForm({ nombre: '', email: '', telefono: '', password: '', especialidad: '', avatar: null });
          setPreview(null);
          if (onSuccess) onSuccess();
        }).catch(err => {
          setError('No se pudo validar reCAPTCHA');
          setLoading(false);
        });
      });
    } catch (err) {
      setError('No se pudo registrar: ' + (err.message || ''));
      setLoading(false);
    }
  };

  return (
    <form className="registro-form" onSubmit={handleSubmit} encType="multipart/form-data">
      <h3>Registro de Neuroterapeuta</h3>
      <input name="nombre" placeholder="Nombre completo" value={form.nombre} onChange={handleChange} required />
      <input name="email" type="email" placeholder="Email" value={form.email} onChange={handleChange} required />
      <input name="telefono" placeholder="Teléfono" value={form.telefono} onChange={handleChange} required />
      <input name="password" type="password" placeholder="Contraseña" value={form.password} onChange={handleChange} required />
      <textarea name="especialidad" placeholder="Especialidad, Bio o CV" value={form.especialidad} onChange={handleChange} rows={3} />
      <label>Foto (opcional): <input name="avatar" type="file" accept="image/*" onChange={handleChange} /></label>
      {preview && <div><img src={preview} alt="preview" style={{ maxWidth: 120, margin: 8 }} /></div>}
  {/* reCAPTCHA v3 invisible, no widget */}
      <button type="submit" disabled={loading}>{loading ? 'Enviando...' : 'Registrarse'}</button>
      {error && <div className="registro-error">{error}</div>}
      {ok && <div className="registro-ok">Registro enviado. Espera aprobación del superadmin.</div>}
    </form>
  );
}
